import { confirm } from '@/lib/confirm';
import { i18n } from '@/i18n';

type Guard = () => boolean;

const guards = new Map<symbol, Guard>();

export function registerUnsavedDialogGuard(guard: Guard) {
  const id = Symbol('unsaved-dialog-guard');
  guards.set(id, guard);
  return () => {
    guards.delete(id);
  };
}

export function hasUnsavedDialogChanges() {
  return Array.from(guards.values()).some((guard) => guard());
}

export async function confirmDiscardUnsavedDialogChanges() {
  if (!hasUnsavedDialogChanges()) return true;
  return confirm({
    title: i18n.global.t('dialog.discardTitle'),
    description: i18n.global.t('dialog.discardNavigationDescription'),
    confirmText: i18n.global.t('dialog.discardConfirm'),
    cancelText: i18n.global.t('dialog.keepEditing'),
    variant: 'destructive',
  });
}

export function installUnsavedDialogBeforeUnloadGuard() {
  window.addEventListener('beforeunload', (event) => {
    if (!hasUnsavedDialogChanges()) return;
    event.preventDefault();
    event.returnValue = '';
  });
}
